import React from 'react';
import App from 'App';
import { Navigate, createBrowserRouter } from 'react-router-dom';

import ProtectedRoutes from './protectedRoutes';

import TopNavLayout from '../layouts/TopNavLayout';
import ErrorLayout from '../layouts/ErrorLayout';

import Error401 from 'pages/transverses/Error401';
import Error404 from 'pages/transverses/Error404';
import Error500 from 'pages/transverses/Error500';

import InitPasswordBlankPage from 'pages/transverses/InitPassword';

import HomeScreen from 'pages/infosGenerales/homeScreen';
import NousContacter from 'pages/infosGenerales/nousContacter';
import DPSinfo from 'pages/infosGenerales/dpsInfo';
import Recrutement from 'pages/infosGenerales/recrutement';

import DemandeDPS from 'pages/demandeDps/demandeDps';
import DemandeDocsOrga from 'pages/demandeDocsOrga/demandeDocsOrga';

import MesDPS from 'pages/authenticated/mesDPS/mesDPS';
import MesStructures from 'pages/authenticated/mesStructures/mesStructures';
import MonCompte from 'pages/authenticated/monCompte/monCompte';

import OneDPS from 'pages/authenticated/oneDPS/oneDPS';

const routes = [
  {
    element: <App />,
    children: [
      {
        path: 'errors',
        element: <ErrorLayout />,
        children: [
          { path: '/errors/401', element: <Error401 /> },
          { path: '/errors/404', element: <Error404 /> },
          { path: '/errors/500', element: <Error500 /> },
        ]
      },
      {
        path: '/initPassword',
        element: <ErrorLayout />,
        children: [
          { path: '/initPassword/:tokenInitMdp', element: <InitPasswordBlankPage /> },
        ]
      },
      {
        path: '/',
        element: <TopNavLayout />,
        children: [
          { path: '/',             element: <HomeScreen /> },
          { path: '/contact',      element: <NousContacter /> },
          { path: '/dpsInfo',      element: <DPSinfo /> },
          { path: '/recrutement',  element: <Recrutement /> },

          { path: '/demandeDPS',                      element: <DemandeDPS /> },
          { path: '/demandeDPS/:demandeUpdateCode',   element: <DemandeDPS /> },

          {
            path:'/auth',
            element: <ProtectedRoutes />,
            children: [
              { path: '/auth/mesDPS',         element: <MesDPS /> },
              { path: '/auth/mesStructures',  element: <MesStructures /> },
              { path: '/auth/monCompte',      element: <MonCompte /> },
              { path: '/auth/dps/:idDPS',     element: <OneDPS /> }
            ]
          },
        ]
      },

      {
        path: '/',
        element: <ErrorLayout />,
        children: [
          { path: '/requestDocOrga/:docRequestPublicCode',   element: <DemandeDocsOrga /> },
        ]
      },
      { path: '*', element: <Navigate to={'/errors/404'} replace /> }
    ]
  }
];

export const router = createBrowserRouter(routes, {
  basename: process.env.PUBLIC_URL
});

export default routes;
